export default "__VITE_PUBLIC_ASSET__5de157a8__"